import { IPrizeRecord } from '@/models/prizerecord'
import { AppUtil } from 'kuaidong-lib'

export default class APrizeRecord {
  public static async getPrizes(pageNo = 1, pageSize = 30): Promise<IPrizeRecord[]> {
    return AppUtil.httpGET('/web/lucky_draw/prize', { page_no: pageNo, page_size: pageSize })
  }
}
